<template>
  <component-wrapper>
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12">
        <div class="video-fi">
          <video-player-fi
            :aspect-ratio="videoImageRatio"
            :fields="fields"
          />
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import type { VideoPlayerFiFields } from '@/components/video-player-fi/types';
import VideoPlayerFi from '@/components/video-player-fi/VideoPlayerFi.vue';
import { useFields } from '@/composables/fields';

defineOptions({ name: 'VideoFi' });

const fields = useFields<VideoPlayerFiFields>();

const videoImageRatio = computed(() => {
  const width = fields.image?.value?.width;
  const height = fields.image?.value?.height;
  if (width && height) {
    return Number(width) / Number(height);
  }

  // set 16 / 9 ratio default if image width & height are missing
  return 16 / 9;
});
</script>

<style scoped src="./video-fi" />
